import styled from 'styled-components'
import { ExternalLink } from '../external-link/external-link-component'
import { Link } from 'react-router-dom'

export const Wrap = styled.div`
  width: 100%;
  padding: 16px 40px;
  color: ${props => props.theme.color.black};
  position: relative;
  z-index: 5;
  @media screen and (max-width: ${props => props.theme.resolution.sm}) {
    padding: 8px;
  }
`
export const Content = styled.div<{ open?: boolean }>`
  height: 60px;
  max-width: ${props => props.theme.resolution.xxxl};
  width: 100%;
  margin: auto;
  display: flex;
  justify-content: space-between;
  gap: 64px;
  background: ${props => props.theme.color.white};
  border-radius: 16px;
  padding: 8px 24px;
  border: 1px solid ${props => props.theme.color.linkwater};
  box-shadow: rgba(35, 32, 67, 0.08);
  position: relative;

  @media screen and (max-width: ${props => props.theme.resolution.xxl}) {
    gap: 24px;
  }
  @media screen and (max-width: ${props => props.theme.resolution.lg}) {
    ${props => props.open ? 'border-radius: 16px 16px 0 0' : ''};
  }
  @media screen and (max-width: ${props => props.theme.resolution.sm}) {
    height: 52px;
    padding: 10px 12px;
  }
`
export const Nav = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: center;
  gap: 64px;
  & > *:first-child, & > *:last-child {
    margin-left: auto;
  } 
  @media screen and (max-width: ${props => props.theme.resolution.xxl}) {
    gap: 24px;
  }
`
export const SignIn = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`
export const Login = styled(Link)`
  display: flex;
  align-items: center;
  gap: 6px;
  ${props => props.theme.typography.p1};
  text-decoration: none;
  color: ${props => props.theme.color.black};
  cursor: pointer;
`
export const Register = styled(Link)`
  ${props => props.theme.typography.p1};
  color: ${props => props.theme.color.dodgerblue};
  text-decoration: none;
  cursor: pointer;
`
export const StyledOuterLink = styled(ExternalLink)`
  display: flex;
  align-items: center;
  gap: 6px;
  ${props => props.theme.typography.p1};
  text-decoration: none;
  color: ${props => props.theme.color.black};
  cursor: pointer;
  margin-left: auto;
  @media screen and (max-width: ${props => props.theme.resolution.lg}) {
    margin-left: 0;
  }
`
export const User = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
`
